
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommReturnSelectGrid extends _Ext.GridBase<ECommSalesReturnRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReturn'; }
        protected getDialogType() { return ECommSalesReturnDialog; }
        protected getIdProperty() { return ECommSalesReturnRow.idProperty; }
        //protected getInsertPermission() { return ECommReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReturnRow.localTextPrefix; }
        protected getService() { return ECommSalesReturnService.baseUrl; } 
        private autoSize; 

        constructor(container: JQuery,options) {
            super(container,options);

            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as ReportFiltersRequest).PartyId = poscustomerid; 
            } 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
 

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): ECommSalesReturnRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false; 
           return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}